import type { JSX } from 'react';

export const Membership = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4 20C4 19.4696 4.21071 18.9609 4.58579 18.5858C4.96086 18.2107 5.46957 18 6 18H18C18.5304 18 19.0391 18.2107 19.4142 18.5858C19.7893 18.9609 20 19.4696 20 20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V20Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M6.7 18L5.7 17C4.35 15.682 3 14.09 3 12C2.99993 10.6825 3.51985 9.41828 4.44674 8.48203C5.37364 7.54577 6.6326 7.01317 7.95 7C9.534 7 10.65 7.455 12 8.818C13.35 7.455 14.466 7 16.05 7C17.3674 7.01317 18.6264 7.54577 19.5533 8.48203C20.4802 9.41828 21.0001 10.6825 21 12C21 14.082 19.641 15.673 18.3 17L17.3 18"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path d="M10 4H14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    <path d="M12 2V8.818" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
);
